import {
  DataAnalyticsTaggingEvents,
  DataAnalyticsTaggingEventType
} from '@tdwb/core';

export class NotificationHubAnalytics {
  static  notificationHubTaggingEvents: DataAnalyticsTaggingEvents = {
    'pagePreferencesNotification-hub': {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        name: 'notifications hub',
        subSection1: 'preferences',
        subSection2: 'notifications hub',
        customPageName: 'wb_preferences-notifications hub'
      }
    }
  }

  static readonly NOTIFICATION_HUB_TAGGING_CLICK_EVENTS: Record<string, string> = {
    save: 'notifications hub:save',
    toggle: 'notifications hub:trade notifications:on/off',
    expand: 'notifications hub:display preferences:on/off'
  }

  static taggingEvents: DataAnalyticsTaggingEvents = {
    ...this.notificationHubTaggingEvents
  }
}
